export { SegmentedControl } from './SegmentedControl'
export type {
  SegmentedControlOption,
  SegmentedControlOptionState,
  SegmentedControlProps,
  SegmentedControlVariant,
} from './SegmentedControl'
